export default __webpack_public_path__ + "img/special-title-rig_yellow.png?2538";